import { SupporterFeedbackAppEnvironment } from './environment.type';

export const environment: SupporterFeedbackAppEnvironment = {
  production: true,
  name: 'prod',

  settings: {
    apiUrl: '',
  },
};
